import React from 'react';

import {
  errorUtil,
  fields,
  validationUtil
} from 'iron-forge-react-modules';

import { FormModal } from 'modules';
import { useForm } from 'react-hook-form';
import Big from 'big.js';
import * as dataService from './dataService';
import * as types from './types';




const ControlledCheckboxField = fields.CheckboxField.genControllerComponent<types.IFormState>();
const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  listingManagementStrategyId: string;
  value: Big;

  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [
    saveItemPrice,
    saveItemPriceTuple
  ] = dataService.useSaveListingManagementStrategy(props.listingManagementStrategyId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      priceDollars: props.value.toFixed(2),
      overwriteExistingPrices: false
    }
  });

  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      await errorUtil.errorWrap(async () => {
        await saveItemPrice(formState);
      }, {
        INVALID_ARGS: "Error saving item."
      });

      props.onClose();
    },
    [
      props,
      saveItemPrice
    ]
  );

  return (
    <FormModal.FC
      title="Edit Price"
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}
      isLoading={saveItemPriceTuple.loading}>
      <ControlledTextField
        isDisabled={saveItemPriceTuple.loading}
        fieldKey="priceDollars"
        formControl={form.control}
        extraValidationRules={{
          pattern: validationUtil.reDecimalNumber
        }} />

      <ControlledCheckboxField
        label="Overwrite all existing prices?"
        isDisabled={saveItemPriceTuple.loading}
        fieldKey="overwriteExistingPrices"
        formControl={form.control} />
    </FormModal.FC>
  );
};
